var widget_default = {
  "card": "_1RFNt",
  "link": "R5PeH",
  "container": "-BzRd",
  "image": "Jc2cm",
  "right": "v8Dln",
  "cardLayout": "_9isCu",
  "content": "z2XJU",
  "title": "K8LQk",
  "subtitle": "Yv1ks",
  "button": "oF0Ro",
  "button_disabled": "SkrSN",
  "buttonText": "NG3Lb",
  "slimLayout": "VLsHm",
  "contentText": "-muVo"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
